// ***** start - localstorage key for store user data at login *****
export const ADMIN_DETAILS_KEY = "admin-details-key";
export const ADMIN_DETAILS_REMEMBER_KEY = "admin-details-remember-key";
export const USER_DATA = "userData";
export const ADMIN_ROLE = "administrator";
// ***** end - localstorage key for store user data at login *****

/* Pagination */
export const ROWS_PER_PAGE = [7, 10, 25, 50, 100];
export const LIEN_STATUS = {

  lien_search_todo: "Lien Search TO DO",
  lien_search_in_progress: "Lien Search IN PROGRESS",
  lien_search_completed: "Lien Search COMPLETED",
  lien_search_failed: "Lien Search FAILED",
};

export const LIEN_STATUS_API_KEYS = {
  ToDo: "Lien Search TO DO",
  ToReview: "LIEN Summary To REVIEW",
  ToCorrect: "Lien Summary TO CORRECT",
  Approved: "Lien Summary APPROVED",
  WaiverAndPayoutRequest: "Waiver & Payout Request",
  SuccessfullyClosed: "Successfully Closed",
  DealCancelled: "Deal Cancelled",
} as const;
